import classnames from "classnames";
import * as React from "react";

import { Radio } from "..";

/**
 * Prop interface
 */
export interface RadioButtonProps {
  name: string;
  checked?: boolean;
  className?: string;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  // Button Style Props
  outlined?: boolean;
  rounded?: boolean;
  loading?: boolean;
  disabled?: boolean;
  stretch?: boolean;
  // remove min-width
  shrink?: boolean;
  // reduce sides padding
  narrow?: boolean;
  // Accessibility Props
  ariaLabel?: string;
  ariaPressed?: boolean;
  role?: string;
}

/**
 * React Component
 */
export default function RadioButton({
  name,
  checked,
  className,
  onChange,
  children,
  outlined,
  loading,
  disabled,
  stretch,
  shrink,
  rounded,
  narrow,
  ariaLabel,
  ariaPressed,
  role,
}: RadioButtonProps) {
  const rootStyle = classnames("code-c-radiobutton", {
    "is-selected": checked,
    "is-outlined": outlined,
    "is-loading": loading,
    "is-stretch": stretch,
    "is-shrink": shrink,
    "is-rounded": rounded,
    "is-narrow": narrow,
    [`${className}`]: Boolean(className),
  });

  return (
    <Radio
      name={name} // This is the group name for the radio buttons
      checked={checked}
      readOnly={disabled ?? loading}
      className={classnames({ "is-stretch": stretch })}
      labelClassName={rootStyle}
      onChange={onChange}
      ariaLabel={ariaLabel}
      ariaPressed={ariaPressed}
      role={role}
    >
      {children ? children : ""}
    </Radio>
  );
}
